module.exports = __webpack_public_path__ + "static/img/课程资源建设平台.0382fc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/课程资源建设平台.png
// module id = BBqf
// module chunks = 13